export default __webpack_public_path__ + "static/pricingLogo-d1641be5587e19a1617a38126c95c77c.svg";